import axios from 'axios';

export interface TryonRequest {
  phone?: string;
  fabricid: string;
  enterpriseid: string;
  model: 'aitryon' | string;
  useOssRes?: boolean;
  input: {
    top_garment_url: string;
    bottom_garment_url?: string;
    person_image_url: string;
  };
}

export interface TryonTaskResponse {
  status: 'FAILED' | 'SUCCEED' | string;
  message: string;
  output: {
    task_id: string;
    task_status: string;
  };
  request_id: string;
}

export interface TryonStatusResponse {
  status: 'FAILED' | 'SUCCEED' | string;
  message: string;
  output: {
    task_id: string;
    task_status: string;
    submit_time: string;
    scheduled_time: string;
    end_time: string;
    image_url?: string;
  };
  usage: {
    image_count: number;
  };
  request_id: string;
}

export async function createTryonTask(reqParam: TryonRequest): Promise<TryonTaskResponse> {
  const response = await axios.post('https://aimodelproxy-yjtvjpfhep.cn-hangzhou.fcapp.run', reqParam, { validateStatus: () => true });
  if (response.status !== 200) {
    throw new Error(
      `create tryon task fail : ${response.data.message}`
    );
  }
  const taskResponse = response.data;

  if (!taskResponse) {
    throw new Error('Failed to create tryon task');
  }

  return taskResponse;
}

export interface FabricCheckRequest {
  fabricid: string;
  enterpriseid: string;
  model: 'fabric-query';
}

export interface FabricCheckResponse {
  status: 'FAILED' | 'SUCCEED' | string;
  limit: boolean;
}

export async function fabricCheck(reqParam: FabricCheckRequest): Promise<FabricCheckResponse> {
  const response = await axios.post('https://aimodelproxy-yjtvjpfhep.cn-hangzhou.fcapp.run', reqParam, { validateStatus: () => true });
  if (response.status !== 200) {
    throw new Error(
      `create tryon task fail : ${response.data?.message || response.data}`
    );
  }
  const taskResponse = response.data;

  if (!taskResponse) {
    throw new Error('Failed to create tryon task');
  }

  return taskResponse;
}

export async function queryTryonTask(task_id: string, enterpriseid: string): Promise<TryonStatusResponse> {
  const response = await axios.post(`https://aitaskquery-agqnqisgya.cn-hangzhou.fcapp.run`, { task_id, enterpriseid });
  if (response.status !== 200) {
    throw new Error(
      `create tryon task fail : ${response.status} ${response.statusText}`
    );
  }
  const taskResponse = response.data;

  if (!taskResponse) {
    throw new Error('Failed to create tryon task');
  }

  return taskResponse;
}

export async function getFabricEnterpriseId(code: string): Promise<string> {
  try {
    const response = await axios.post('https://aimodelproxy-yjtvjpfhep.cn-hangzhou.fcapp.run', {
      model: 'code-query',
      input: {
        code
      }
    });
    return response.data.enterpriseId;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
}

export async function getDashscopeInstantKey(enterpriseId: string, file: any, fileName: string = 'screenshot.png') {
  const resp = await axios.post('https://aimodelproxy-yjtvjpfhep.cn-hangzhou.fcapp.run', {
    'model': 'uppolicy',
    'enterpriseid': enterpriseId,
    'input': {
      'require_model': 'aitryon'
    }
  });

  const {
    upload_host,
    upload_dir,
    policy,
    oss_access_key_id,
    signature,
    x_oss_forbid_overwrite,
    x_oss_object_acl
  } = resp.data.data;
  const key = `${upload_dir}/${fileName}`;

  const form = new FormData();
  form.set('OSSAccessKeyId', oss_access_key_id);
  form.set('policy', policy);
  form.set('Signature', signature);
  form.set('x-oss-object-acl', x_oss_object_acl);
  form.set('x-oss-forbid-overwrite', x_oss_forbid_overwrite);
  form.set('key', key);
  form.set('success_action_status', '200');
  form.set('file', file);

  await axios.post(upload_host, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-oss-object-acl': x_oss_object_acl
    }
  });

  return key;
}
